"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsComponents = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _ToggleOn = _interopRequireDefault(require("@mui/icons-material/ToggleOn"));
var _ToggleOff = _interopRequireDefault(require("@mui/icons-material/ToggleOff"));
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _DmsExport = require("../DmsExport/DmsExport");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _DmsModal = require("../DmsModal/DmsModal");
var _HttpStatus = require("../../constants/HttpStatus");
var _Permissions = require("../../constants/Permissions");
var _ComponentsStatus = require("../../constants/ComponentsStatus");
var _notifications = require("../../service/notifications/notifications");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// DMS Components

// Constants and Services

/**
 * Component for managing system components with CRUD operations and status toggling.
 * @param {Object} props - Component props
 * @param {React.ReactNode} [props.toolbar] - Custom toolbar to override default table toolbar
 * @returns {React.ReactElement} Components management interface
 */
const DmsComponents = _ref => {
  let {
    toolbar
  } = _ref;
  const table = (0, _react.useRef)(null);
  const token = (0, _DmsTokenHook.getToken)();
  const [isModalOpen, setModalOpen] = (0, _react.useState)(false);
  const [itemToToggle, setItemToToggle] = (0, _react.useState)(null);

  /**
   * Handles status toggle click event
   * @param {Object} item - Component item to toggle
   */
  const handleToggleClick = item => {
    setItemToToggle(item);
    setModalOpen(true);
  };

  /**
   * Executes status toggle operation
   */
  const onToggleStatus = async () => {
    if (!itemToToggle) return;
    try {
      const res = await (0, _DmsFetch.fetchData)("/component/toggle/".concat(itemToToggle.pk), 'PUT', token);
      if (res.status === _HttpStatus.HTTP_STATUS.OK_200) {
        table.current.updateTable();
        _notifications.Notifications.toast(_reactIntlUniversal.default.get("Success").d("Success"), _notifications.Notifications.TYPE_SUCCESS);
      }
    } catch (error) {
      console.error("Toggle status failed:", error);
    } finally {
      setModalOpen(false);
      setItemToToggle(null);
    }
  };

  // Table configuration
  const header = [{
    label: 'status',
    column_name: "status",
    filter: false,
    permissions: [_Permissions.Permissions.CAN_EDIT_COMPONENT_STATUS],
    control: 'switch',
    function: (value, item) => /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
      onClick: () => handleToggleClick(item),
      icon: value === _ComponentsStatus.ComponentStatus.STATUS_ENABLE ? /*#__PURE__*/_react.default.createElement(_ToggleOn.default, null) : /*#__PURE__*/_react.default.createElement(_ToggleOff.default, null),
      variant: value === _ComponentsStatus.ComponentStatus.STATUS_ENABLE ? 'success' : 'danger'
    })
  }, {
    label: _reactIntlUniversal.default.get("UUID").d("UUID"),
    column_name: "uuid",
    filter: true,
    permissions: [_Permissions.Permissions.POLLUX_PERMISSION]
  }, {
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("IPV4").d("IPV4"),
    column_name: "ipv4",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Port").d("Port"),
    column_name: "port",
    filter: true,
    fieldtype: 'int'
  }, {
    label: _reactIntlUniversal.default.get("UUID").d("UUID"),
    column_name: "uuid",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Type").d("Type"),
    column_name: "component_type",
    form_column_name: "component_type_pk",
    control: 'select',
    url: "/component_type/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: "name",
      text_template: '{name}',
      filter: {
        value: 'pk',
        field: 'component_type_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Parent").d("Parent"),
    column_name: "parent",
    control: 'select',
    url: "/thing/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: "name",
      text_template: '{name}',
      filter: {
        value: 'pk',
        field: 'parent_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    column_name: "actions",
    permissions: [_Permissions.Permissions.CAN_EDIT_COMPONENT],
    width: "80px",
    sortable: false,
    can_create: false,
    element: row => {
      const component_name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateComponent", {
          component_name
        }).d("Update {component_name}"),
        url: "/component",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteComponent", {
          component_name
        }).d("Delete {component_name}"),
        text: _reactIntlUniversal.default.get("Components.DeleteButtonMessage", {
          component_name
        }).d("The component {component_name} will be deleted. Are you sure about it?"),
        url: "/component",
        row_pk: row.pk
      }));
    }
  }];
  const renderToolbar = toolbar || /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_COMPONENT
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateComponent").d("Create component"),
    url: "/component",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  const renderModal = () => {
    const name = itemToToggle.name;
    return /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
      isVisible: isModalOpen,
      onClose: () => setModalOpen(false)
    }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
      title: (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.status) === _ComponentsStatus.ComponentStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("DeactivateItem", {
        name
      }).d("Deactivate {name}") : _reactIntlUniversal.default.get("ActivateItem", {
        name
      }).d("Activate {name}"),
      onClose: () => setModalOpen(false)
    }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.status) === _ComponentsStatus.ComponentStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("ConfirmDeactivate", {
      name
    }).d("Are you sure you want to deactivate {name}?") : _reactIntlUniversal.default.get("ConfirmActivate", {
      name
    }).d("Are you sure you want to activate {name}?")), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
      variant: "primary",
      text: (itemToToggle === null || itemToToggle === void 0 ? void 0 : itemToToggle.status) === _ComponentsStatus.ComponentStatus.STATUS_ENABLE ? _reactIntlUniversal.default.get("Deactivate").d("Deactivate") : _reactIntlUniversal.default.get("Activate").d("Activate"),
      onClick: onToggleStatus
    })));
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "/component/table",
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: renderToolbar,
    responsive: true
  }), itemToToggle && renderModal());
};
exports.DmsComponents = DmsComponents;
DmsComponents.propTypes = {
  /** Custom toolbar component to override default table toolbar */
  toolbar: _propTypes.default.node
};